<template>
  <main>
    <SnapsheetsTemplatesHeader
      @search-input-change="handleSearchInput"
      @toggleActiveFilter="handleToggleActiveFilter"
      :filters="filters"
      :activeFilter="activeFilter"
    />
    <SnapsheetsTemplatesContainer :templates="filteredTemplates" />
  </main>
</template>

<script>
import SnapsheetsTemplatesHeader from "@/components/Dashboard/SnapsheetsTemplates/SnapsheetsTemplatesHeader.vue";
import SnapsheetsTemplatesContainer from "@/components/Dashboard/SnapsheetsTemplates/SnapsheetsTemplatesContainer.vue";
import { mapState } from "vuex";
export default {
  name: "SnapsheetsTemplates",
  components: { SnapsheetsTemplatesHeader, SnapsheetsTemplatesContainer },

  data() {
    return {
      searchFilter: "",
      activeFilter: "all",
      filters: ["all", "color", "collection", "occasion"],
    };
  },

  computed: {
    ...mapState("snapsheet", ["snapsheetsTemplates"]),

    activeFilters() {
      return Object.keys(this.filters)?.filter(
        (filter) => this.filters[filter]
      );
    },

    filteredBySearchQuery() {
      return this.snapsheetsTemplates?.filter((template) => {
        if (!this.searchFilter.length) {
          return template;
        }

        const titleContainsSearchQuery =
          template.title
            ?.toLowerCase()
            .indexOf(this.searchFilter?.toLowerCase()) !== -1;
        const subtitleContainsSearchQuery =
          template.subtitle
            ?.toLowerCase()
            .indexOf(this.searchFilter?.toLowerCase()) !== -1;

        return titleContainsSearchQuery || subtitleContainsSearchQuery;
      });
    },

    filteredTemplates() {
      return this.filteredBySearchQuery?.filter((template) => {
        if (this.activeFilter === "all") {
          return this.snapsheetsTemplates;
        } else {
          return template.type.toLowerCase() === this.activeFilter;
        }
      });
    },
  },

  methods: {
    handleSearchInput(inputValue) {
      this.searchFilter = inputValue;
    },

    handleToggleActiveFilter(filter) {
      this.activeFilter = filter;
    },
  },
};
</script>

<style lang="scss" scoped>
main {
  background-color: white;
  max-width: 1920px;
  margin: auto;
  padding: 0 4rem;

  * {
    color: black;
  }
}
</style>
